import styled from 'styled-components';

export const Button = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${p => p.theme.colors.main.orangeLight};
  border: 1px solid ${p => p.theme.colors.main.orangeMain};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonsWrap = styled.div`
  gap: 8px;
  display: flex;
  justify-content: center;
  z-index: 5;
`;
